module.exports = __webpack_public_path__ + "img/emoji_102.3d30f747.png";